export default "__VITE_ASSET__DQTsnsJG__"